import __var_0__ from './iso_weeks_in_year.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Determine the number of ISO weeks in a year according to the Gregorian calendar.
*
* @module @stdlib/time/iso-weeks-in-year
*
* @example
* var isoWeeksInYear = require( '@stdlib/time/iso-weeks-in-year' );
*
* var num = isoWeeksInYear();
* // returns <number>
*
* num = isoWeeksInYear( 2015 );
* // returns 53
*
* num = isoWeeksInYear( 2017 );
* // returns 52
*/

// MODULES //
var isoWeeksInYear = __var_0__;


// EXPORTS //
export default isoWeeksInYear;
